import React from "react";

import ThemeContext from "~/common/ThemeContext";
import { ReactComponent as ConnectedDarkIconSVG } from "~/legacy-assets/images/icons/connected-dark.svg";
import { ReactComponent as ConnectedIconSVG } from "~/legacy-assets/images/icons/connected.svg";

export function ConnectedIcon({
	inverted = false,
	...props
}: React.ComponentProps<typeof ConnectedIconSVG> & { inverted?: boolean }) {
	const { isDarkMode } = React.useContext(ThemeContext);
	// "isDarkMode" XOR "inverted"; JS has an XOR operator (^) but it's bitwise, not logical
	return isDarkMode !== inverted ? <ConnectedDarkIconSVG {...props} /> : <ConnectedIconSVG {...props} />;
}
